import {Component, computed, inject, input, signal, WritableSignal} from '@angular/core';
import {MatFormField} from '@angular/material/input';
import {MatOption, MatSelect} from '@angular/material/select';
import {TranslateModule} from '@ngx-translate/core';
import {take} from 'rxjs/operators';
import {IackathonSavesService} from '../../services/iackathon-saves.service';

@Component({
    selector: 'app-iackathon-learner-self-reviews',
    imports: [
        MatFormField,
        MatSelect,
        MatOption,
        TranslateModule
    ],
    templateUrl: './iackathon-learner-self-reviews.component.html',
    styleUrl: './iackathon-learner-self-reviews.component.scss',
})
export class IackathonLearnerSelfReviewsComponent {
    public targetSaveId = input.required<string>();

    private iackathonSavesService = inject(IackathonSavesService);
    protected readonly isLoading = signal(false);
    protected readonly groupSaves = this.iackathonSavesService.cachedSaves;
    protected readonly targetSave = computed(() => this.groupSaves().find(save => save.id === this.targetSaveId()) ?? null);
    protected readonly selectedGroupReviewer = signal('none');
    protected readonly anotherWayGroupIndex = signal<number>(0);
    protected readonly commentGroupIndex = signal<number>(0);

    constructor() {
        if (this.iackathonSavesService.cachedSaves().length === 0) {
            this.isLoading.set(true);
            this.iackathonSavesService.fetchSaves().pipe(
                take(1)
            ).subscribe(() => this.isLoading.set(false));
        }
    }

    protected getReviewCount(key: string, target: number, groupIdFilter: string) {
        const targetSaveId = this.targetSaveId();

        if (groupIdFilter === 'none') {

        return this.groupSaves()
            .reduce((acc, group) => {
                    const reviews = group.attributes.content.state.groups_project_reviews;
                    if (!(targetSaveId in reviews)) {
                        return acc;
                    }

                    return reviews[targetSaveId][key] === target ? acc + 1 : acc;
                },
                0);
        } else {
            const groupReviewer = this.groupSaves().find(save => save.id === groupIdFilter);
            if (!groupReviewer) return '-';

            const state = groupReviewer.attributes.content.state;
            const reviews = state.groups_project_reviews;
            if (!(targetSaveId in reviews)) return '-';

            return reviews[targetSaveId][key] === target ? 1 : '-';

        }
    }

    protected onSelectedGroupReviewerChange(selectedGroupReviewerId: string): void {
        this.selectedGroupReviewer.set(selectedGroupReviewerId);
    }

    protected onChangeIndexClick(signal: WritableSignal<number>, number: number) {

        signal.update(value => {
            value += number;
            value = value < 0 ? 0 : value;
            value = value >= this.groupSaves().length ? this.groupSaves().length - 1 : value; // -2 parce qu'on retire son propre groupe
            return value;
        });
    }
}
